import React from 'react';
import Select from 'shared/inputs/BaseSelect';

const FieldsToSelectDropdown = ({ fields, onFieldChanged, value }) => {

  const displayValue = typeof value === 'object' ? value : fields.find((x) => x.field === value);
  return (
    <Select
      data={fields}
      onChange={onFieldChanged}
      textField="displayName"
      dataItemKey="field"
      value={displayValue}
    />
  );
};

export default FieldsToSelectDropdown;
